/**
 * Lazy-read the Redux store so this module does not participate in the
 * persistState → contextTracker → socket → getId → persistState init cycle
 * (webpack TDZ / "__WEBPACK_DEFAULT_EXPORT__ before initialization").
 */
function handleGetID(data: any) {
	return data?.promiseData?.data?.userData?.id;
}

const getId = () => {
	// Alias-resolved require — must not be a static import of persistState.
	// eslint-disable-next-line @typescript-eslint/no-var-requires
	const { store } = require('@reduxLocal/persistState');
	const data = store.getState();
	return handleGetID(data);
};

export default getId;
